
import React from "react";
import { useNavigate } from "react-router-dom";

function Header() {
  const navigate = useNavigate();

  const username = sessionStorage.getItem("username");
  const company = sessionStorage.getItem("companyName");
  const address = sessionStorage.getItem("address");
  const handleLogout = () => {
    sessionStorage.clear();
    navigate("/");
  };

  return (
    <div
      className="d-flex justify-content-between align-items-center px-4 py-2 shadow-sm"
      style={{
        backgroundColor: "#800000", // Maroon
        color: "#FFD700", // Gold text
        width: "100%",
        // position: "sticky",
        // top: 0,
        // zIndex: 1000, // stays above content
        marginTop: 0, 
      }}
    >
      {/* Company Name */}
      <div className="d-flex flex-column">
        <h3 className="fw-bold m-0" style={{ color: "#e6cb38ff" }}>
          {company}
        </h3>

        <h5 className="fw-bold m-0" style={{ color: "#e6cb38ff" }}>
          {address}
        </h5>
      </div>

      {/* User + Logout */}
      <div className="d-flex align-items-center gap-3">
        <span style={{ color: "#e6cb38ff", fontWeight: "500" }}>
          Welcome, {username}
        </span>
        <button
          className="btn btn-sm"
          style={{
            backgroundColor: "#e6cb38ff",
            // color: "#800000",
            color: "#0284c7",
            fontWeight: "600",
            borderRadius: "6px",
          }}
          onClick={handleLogout}
        >
          Logout
        </button>
      </div>
    </div>
  );
}

export default Header;






// import React from "react";
// import { useNavigate } from "react-router-dom";
// import "../css/Header.css"; 

// function Header() {
//   const navigate = useNavigate();

//   // Get username from sessionStorage
//   const username = sessionStorage.getItem("username");
//     const companyname = sessionStorage.getItem("companyName");
//   // Handle logout
//   const handleLogout = () => {
//     sessionStorage.clear(); // clear all session data
//     navigate("/login"); // redirect to login page
//   };

//   return (
//     <header className="header-container">
//       <div className="company-name">🏢 {companyname}</div>

//       <div className="user-section">
//         <span className="username">👤 {username}</span>
//         <button className="logout-btn" onClick={handleLogout}>
//           🚪 Logout
//         </button>
//       </div>
//     </header>
//   );
// }

// export default Header;


// import React from "react";
// import { useNavigate } from "react-router-dom";

// function Header() {
//   const navigate = useNavigate();

//   const username = sessionStorage.getItem("username");
//   const company = sessionStorage.getItem("companyName");

//   const handleLogout = () => {
//     sessionStorage.clear();
//     navigate("/");
//   };

//   return (
//     <div
//       className="d-flex justify-content-between align-items-center px-4 py-2 shadow-sm"
//       style={{
//         backgroundColor: "#da1111ff", // Maroon
//         color: "#FFD700", // Gold text
//         borderRadius: "8px",
//       }}
//     >
//       {/* Company Name */}
//       <h3 className="fw-bold m-0" style={{ color: "#e6cb38ff" }}>
//         {company}
//       </h3>

//       {/* User + Logout */}
//       <div className="d-flex align-items-center gap-3">
//         <span style={{ color: "#e6cb38ff", fontWeight: "500" }}>
//           Welcome, {username}
//         </span>
//         <button
//           className="btn btn-sm"
//           style={{
//             backgroundColor: "#FFD700",
//             color: "#800000",
//             fontWeight: "600",
//             borderRadius: "6px",
//           }}
//           onClick={handleLogout}
//         >
//           Logout
//         </button>
//       </div>
//     </div>
//   );
// }

// export default Header;

